import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaymentNetworkIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 29,
	height: 29,
	viewBox: "0 0 29 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9957 25.0796C19.6451 25.0796 25.0355 19.6892 25.0355 13.0398C25.0355 6.3904 19.6451 1 12.9957 1C6.34633 1 0.955933 6.3904 0.955933 13.0398C0.955933 19.6892 6.34633 25.0796 12.9957 25.0796Z",
			stroke: "#85A0AD",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3787 25.0641C9.40642 21.9338 7.57788 17.6973 7.57788 13.0394C7.57788 8.3815 9.40642 4.14499 12.3787 1.01465",
			stroke: "#85A0AD",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5977 25.0641C16.57 21.9338 18.3985 17.6973 18.3985 13.0394C18.3985 8.3815 16.57 4.14499 13.5977 1.01465",
			stroke: "#85A0AD",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.6726 20.2034C20.1141 18.3749 16.7129 17.2537 12.9956 17.2537C9.27078 17.2537 5.87706 18.3673 3.3186 20.2034",
			stroke: "#85A0AD",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.3186 5.87622C5.87706 7.70476 9.2783 8.82597 12.9956 8.82597C16.7204 8.82597 20.1141 7.71229 22.6726 5.87622",
			stroke: "#85A0AD",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.4983 28C24.6404 28 27.9983 24.6421 27.9983 20.5C27.9983 16.3579 24.6404 13 20.4983 13C16.3562 13 12.9983 16.3579 12.9983 20.5C12.9983 24.6421 16.3562 28 20.4983 28Z",
			fill: "#FF3131"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.4983 28C24.6404 28 27.9983 24.6421 27.9983 20.5C27.9983 16.3579 24.6404 13 20.4983 13C16.3562 13 12.9983 16.3579 12.9983 20.5C12.9983 24.6421 16.3562 28 20.4983 28Z",
			stroke: "black",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.4983 28C24.6404 28 27.9983 24.6421 27.9983 20.5C27.9983 16.3579 24.6404 13 20.4983 13C16.3562 13 12.9983 16.3579 12.9983 20.5C12.9983 24.6421 16.3562 28 20.4983 28Z",
			stroke: "white",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.5392 24.2142V22.9761",
			stroke: "white",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.5392 16.7856V18.0238",
			stroke: "white",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.6025 19.6743V19.2616C22.6025 18.5754 22.0505 18.0234 21.3644 18.0234H19.7136C19.0275 18.0234 18.4755 18.5754 18.4755 19.2616C18.4755 19.9477 19.0275 20.4997 19.7136 20.4997H21.3644C22.0505 20.4997 22.6025 21.0517 22.6025 21.7378C22.6025 22.4239 22.0505 22.9759 21.3644 22.9759H19.7136C19.0275 22.9759 18.4755 22.4239 18.4755 21.7378V21.3251",
			stroke: "white",
			strokeMiterlimit: 10
		})
	]
});
export default SvgPaymentNetworkIcon;
